import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

export interface AddTagsDialogData {
  accountGroupId: string;
  opportunityId: string;
  opportunityTags: string[];
  availableTags?: string[];
}
export type AddTagsDialogResult = string[] | null;

@Component({
  templateUrl: './add-tags-dialog.component.html',
  standalone: false,
})
export class AddTagsDialogComponent {
  tagsControl = new FormControl<string[]>([]);
  filteredTags: string[] = [];
  private availableTags: string[] = [];

  constructor(
    private readonly dialogRef: MatDialogRef<AddTagsDialogComponent, AddTagsDialogResult>,
    @Inject(MAT_DIALOG_DATA) private readonly data: AddTagsDialogData,
  ) {
    this.availableTags = this.data?.availableTags || [];
    this.filterTags('');
    this.tagsControl.setValue(this.data?.opportunityTags ?? []);
  }

  private filterTags(searchText: string): void {
    this.filteredTags = this.availableTags.filter((tag) => tag?.toLowerCase().includes(searchText.toLowerCase()));
  }

  searchTextChanged(searchText: string): void {
    this.filterTags(searchText);
  }

  save(): void {
    this.dialogRef.close(this.tagsControl.value);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
